import React, { createContext, useContext } from 'react';

const ShellContext = createContext({
  isShellActive: false
});

export const ShellProvider = ({ isShellActive, children }) => {
  return (
    <ShellContext.Provider value={{ isShellActive }}>
      {children}
    </ShellContext.Provider>
  );
};

export const useShellContext = () => useContext(ShellContext);
